import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { VehicleSaleQueryResult, CurrentSaleQueryResult } from 'contexts/ApiContext/services/sale'

export interface HandlingFeesProps {
  vehicle: VehicleSaleQueryResult
  currentSale: CurrentSaleQueryResult
  note?: boolean | undefined
}

const HandlingFees: FC<HandlingFeesProps> = ({ currentSale, vehicle, note }) => {
  const { formatMessage } = useIntl()

  let handlingFees
  const vehicleClass = {
    0: 'CL',
    1: 'CYC',
    2: 'CYCL',
    3: 'MTL',
    4: 'MTT1',
    5: 'MTT2',
    6: 'QM',
    7: 'TM',
  }
  if (currentSale?.country === 'France') {
    if (
      vehicle?.batteryCertificate &&
      !vehicle?.broken &&
      vehicle?.category !== 'Moto' &&
      vehicle?.category !== 'Sans Permis' &&
      !Object.values(vehicleClass).includes(vehicle?.class)
    ) {
      handlingFees = 285
    } else {
      handlingFees = 200
    }
  } else {
    handlingFees = 200
  }

  let id
  if (note) {
    id = 'client.footer.footnote.one'
  } else {
    id = 'client.auction.fees_extra'
  }

  return <>{formatMessage({ id: id }, { handlingFees: handlingFees })}</>
}

export default HandlingFees
